import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ErrorPage from '../../errorPage/ErrorPage';
import NotFoundPage from 'errorPage/404';

class PrivateRoute extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { component: Component, authed, routes, ...rest } = this.props;
    return [
      <Route
        {...rest}
        key='route'
        render={props => {
          if (authed === true) {
            if (!window.profile || (window.profile && window.profile.errorType === '404')) {
              // props['errorType'] = 'error404';
              // return <ErrorPage {...props} {...rest} />;
              return <NotFoundPage />;
            }

            if (window.profile && window.profile.clientStatusValue === 'Suspended') {
              props['errorType'] = 'suspended';
              return <ErrorPage {...props} {...rest} />;
            }

            if (window.profile && window.profile.errorType === 'general') {
              props['errorType'] = 'general';
              return <ErrorPage {...props} {...rest} />;
            }

            return <Component {...Object.assign(props, {routes: routes})} />;
          } else {
            return <Redirect to={{ pathname: '/sign-in', state: { from: props.location }}}/>;
          }
        }
        }
      />];
  }
}
PrivateRoute.propTypes = {
  location: PropTypes.any,
  component: PropTypes.any,
  routes: PropTypes.array,
  authed: PropTypes.bool
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/Router/PrivateRoute.js